class vehicalcolor {
    constructor(msg) {
        this.items =
        {
            id: 30001,
            name: "Custom Vehicle Make",
            type: "text",
            slideimg: "/doctorassistant/dia.jpg",
            options: [
                { id: 40012, text: "Submit", name: "Submit", type: "vehicalcolorConfirm", desc: msg.desc, inputtype: "textinput",  },
            ], 
            backtostart: false,
            text: [
                `<p>Please provide the color of your vehicle.</p> `
            ]
        }
    }

    getAllItems() {
        console.log(sessionStorage.getItem("car_information"));
        return this.items;
    }
}

export default vehicalcolor;
